module.exports = "<p class=\"no-access\">\n  Access Denied\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/no-access/no-access.component.html
// module id = ../../../../../src/app/shared/components/no-access/no-access.component.html
// module chunks = main